module.exports = __webpack_public_path__ + "static/media/rating_3.dd16b395.svg";